import { render, staticRenderFns } from "./ConfiguraCampos.vue?vue&type=template&id=ecbde9fe&scoped=true"
import script from "./ConfiguraCampos.vue?vue&type=script&lang=js"
export * from "./ConfiguraCampos.vue?vue&type=script&lang=js"
import style0 from "./ConfiguraCampos.vue?vue&type=style&index=0&id=ecbde9fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbde9fe",
  null
  
)

export default component.exports